import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: "Al completamento del pagamento riceverai un'email con accesso immediato a tutti i PDF. Scaricali sul tuo telefono, tablet o computer e usali da oggi stesso."
}, {
  q: 'È utile se sono un nuovo insegnante o se ho esperienza?',
  a: 'Sì per entrambi. Se sei nuovo: hai tutto organizzato dal primo giorno. Se hai già esperienza: troverai idee, variazioni e strutture che non avevi sistematizzato.'
}, {
  q: 'I 6 Bonus sono in entrambe le opzioni?',
  a: 'Sì. I 6 Bonus sono inclusi sia nel Pack Professionale che nel Megapack Élite. La differenza sono i 2 Ebooks Élite esclusivi.'
}, {
  q: "Che differenza c'è con altri materiali di Pilates già esistenti?",
  a: "PILATES 360 è l'unico sistema pensato specificamente per l'insegnante di Pilates, con progressione reale per livelli, esercizi illustrati, Reformer e Mat in un solo posto, e un piano annuale completo incluso."
}, {
  q: 'È utile per gruppi con livelli misti?',
  a: 'Sì. Ogni tomo include variazioni essenziale, classica e avanzata dello stesso esercizio per permetterti di fare una sola lezione con tre livelli senza pianificare tre volte.'
}, {
  q: 'Cosa succede se non mi è utile?',
  a: 'Hai 7 giorni di garanzia totale. Se per qualsiasi motivo non è quello che ti aspettavi, ti rimborsiamo il 100% del pagamento. Senza moduli né domande.'
}, {
  q: 'Vale la pena il Megapack Élite se pianifico già bene le mie lezioni?',
  a: "Se pianifichi già bene, l'Élite #2 (Variazioni Infinite) ti darà 100 nuove variazioni degli esercizi che già usi. E l'Élite #1 ti darà l'intero anno strutturato senza lavoro extra. Il tempo che risparmi in un mese giustifica già la differenza di prezzo."
}, {
  q: 'Posso pagare con carta di credito?',
  a: 'Sì. Accettiamo tutte le carte di credito e debito, bonifico bancario e pagamenti sicuri online.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-white" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        {/* FAQ Section */}
        <div data-id="element-55">
          <h2 className="text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-56">
            Domande Frequenti
          </h2>
          <div className="space-y-4" data-id="element-57">
            {faqs.map((faq, i) => <div key={i} className="border border-brand-sand rounded-xl overflow-hidden" data-id="element-58">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center bg-brand-cream hover:bg-brand-sand/20 transition-colors" data-id="element-59">
                  <span className="font-bold text-brand-charcoal pr-4" data-id="element-60">
                    {faq.q}
                  </span>
                  <ChevronDown className={`transform transition-transform duration-300 text-brand-terracotta flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-61" />
                </button>
                <AnimatePresence data-id="element-62">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-63">
                      <div className="px-6 py-4 bg-white text-gray-600 leading-relaxed border-t border-brand-sand" data-id="element-64">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};